<tilby-dialog-toolbar mat-dialog-title
    (confirm)="confirm()"
    [hideConfirm]="_operationInProgress() || !_form?.valid"
    [title]="'CASHREGISTER.ADD_CASH_MOVEMENT_DIALOG.TITLE'"
/>
@if(_operationInProgress()) {
    <tilby-dialog-progress-bar />
}
<tilby-dialog-content>
    @if(_form) {
        <tilby-magic-form [form]="_form"/>
    }
</tilby-dialog-content>
